import groq from 'groq';
import type { SiteCategory } from 'types/common/SiteCategory';

import { ASSET } from '../common';
import { PRODUCT_SLUG } from '../product';
import { productHref } from '../product/productHref';

const negativeBoostedProducts = ['trial', 'sample', 'refill', 'mini'];

const negativeBoostedProductsQuery = negativeBoostedProducts
  .map((product) => `store.title match "${product}"`)
  .join(' || ');

export const searchProducts = ({
  productSlugs,
  siteCategory,
}: {
  productSlugs?: string[];
  siteCategory: SiteCategory;
}) => {
  const slugsQueryList = productSlugs?.map((slug) => `"${slug}"`).join(',');

  /* WARN: If you change this query, make sure to update MAX_POSSIBLE_SCORES */
  return groq`
    *[
      _type == "product" && 
      category == "${siteCategory}" &&
      !(_id in path("drafts.**")) &&
      ${productSlugs && productSlugs.length > 0 ? `store.slug.current in [${slugsQueryList}]` : ''}
    ] |
      score(
        boost(store.title match $searchTerm && !(${negativeBoostedProductsQuery}), 2),
        boost(ingredientsList[] match $searchTerm && !(${negativeBoostedProductsQuery}), 2),
        store.title match $searchTerm,
        shortDescription match $searchTerm,
        pt::text(longDescription) match $searchTerm,
        pt::text(bulletPointsV2) match $searchTerm,
        references(*[_type == "timeline_productBenefits" && pt::text(description[]) match $searchTerm]._id),
        references(*[_type == "timeline_certifications" && logos[].label match $searchTerm]._id),
      ) {
        _type,
        ${PRODUCT_SLUG},
        ${productHref()},
        "title": store.title,
        "image": thumbnails[0] {
          ${ASSET}
        },
        _score
      } | order(_score desc)[ _score > 0 ][0...3] | order(length(title) asc)
  `;
};
